"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CustomerReducer = undefined;

var _nodeToolbox = require("@esnpm/node-toolbox");

var _translate = require("@esnpm/translate");

var _apiCustomerByEmail = require("../actions/esdb/apiCustomerByEmail");

var _apiCustomerByEmailForEditor = require("../actions/esdb/apiCustomerByEmailForEditor");

var _apiCustomer_post = require("../actions/esdb/apiCustomer_post");

var CustomerReducer = exports.CustomerReducer = function CustomerReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		data: {},
		loading: false,
		error: null
	};
	var action = arguments[1];

	var newState = void 0;
	switch (action.type) {
		case _apiCustomerByEmail.API_CUSTOMER_BY_EMAIL_REQUEST:
		case _apiCustomerByEmailForEditor.API_CUSTOMER_BY_EMAIL_FOR_EDITOR_REQUEST:
		case _apiCustomer_post.API_CUSTOMER_POST_REQUEST:
			newState = Object.assign({}, state, {
				loading: action.payload.loading,
				error: state.error,
				data: state.data
			});
			return newState;
			break;

		case _apiCustomerByEmail.API_CUSTOMER_BY_EMAIL_SUCCESS:
		case _apiCustomer_post.API_CUSTOMER_POST_SUCCESS:
		case _apiCustomerByEmailForEditor.API_CUSTOMER_BY_EMAIL_FOR_EDITOR_SUCCESS:
			var dataCopy = Object.assign({}, state.data);
			dataCopy[action.payload.data["CUSTOMER_ID"]] = action.payload.data;
			return Object.assign({}, state, {
				loading: action.payload.loading,
				data: dataCopy
			});
			break;

		default:
			return state;
	}
};